import React from "react"
import VideoEmbed, { VIDEO_URL_REGEX } from "components/VideoEmbed"
import { Image } from "@chakra-ui/react"
import placeholderImage from "assets/images/placeholder-image.svg"

type EventVideoOrImageProps = {
  portalShowEventImage: boolean
  portalShowEventVideo: boolean
  portalEventVideoUrl: string | null
  eventImageUrl: string
  portalEventImageUrl: string | null
  portalEventImageScale: number
}

const EventVideoOrImage = ({
  portalShowEventImage,
  portalShowEventVideo,
  portalEventVideoUrl,
  portalEventImageUrl,
  eventImageUrl,
  portalEventImageScale,
}: EventVideoOrImageProps) => {
  if (portalShowEventVideo && portalEventVideoUrl?.match(VIDEO_URL_REGEX)) {
    return <VideoEmbed url={portalEventVideoUrl} autoplay />
  }

  if (portalShowEventImage) {
    return (
      <Image
        data-testid="event-image"
        src={eventImageUrl}
        w={portalEventImageUrl ? `${portalEventImageScale}%` : undefined}
      />
    )
  }

  return <Image data-testid="event-image" src={placeholderImage} />
}

export default EventVideoOrImage
